import { render, staticRenderFns } from "./volunteer-add.vue?vue&type=template&id=a0f53a48&"
import script from "./volunteer-add.vue?vue&type=script&lang=js&"
export * from "./volunteer-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports